import React from "react";
import atoms from "../../../atoms";
import { AllProductListProps, BulkInternalTransferProps } from "./interface";
import { priceTagFormatter } from "../../../../constants/utils";
import { IoIosCloseCircleOutline } from "react-icons/io";

const { Select, BarcodeSearch, Table, CustomImages, Button } = atoms;

const Index = ({
    handleSelectStore,
    storeList,
    searchTabContainer,
    handleSearch,
    setPreviewTab,
    previewTab,
    productDataTable,
    handleRemoveProduct,
    handleSubmit,
    selectedStore,
}: BulkInternalTransferProps) => {
    const columns = [
        {
            name: "Product Type",
            selector: (row: AllProductListProps) => row?.product_id_display || "-",
        },
        {
            name: "Cover Photo",
            cell: (row: AllProductListProps) => (
                <CustomImages src={row?.images[0] || ""} imageHeight="10px" />
            ),
            center: true,
        },
        {
            name: "Brand",
            selector: (row: AllProductListProps) => row?.brand.brand_name || "-",
        },
        {
            name: "Model No.",
            selector: (row: AllProductListProps) => row?.modal_number || "-",
        },
        {
            name: "Brand Color Code",
            selector: (row: AllProductListProps) => row?.brand_color_code,
            sortable: true,
        },
        {
            name: "Glass Size",
            cell: (row: AllProductListProps) => row?.glass_size || "-",
            center: true,
        },
        {
            name: "With Case",
            selector: (row: AllProductListProps) =>
                row?.product_with_case ? "true" : " false",
        },
        {
            name: "SRP",
            selector: (row: AllProductListProps) => priceTagFormatter(row?.product_srp) || "-",
        },
        { name: "Action", selector: (row: any) => row.action },
    ];

    return (
        <>
            <div className="row">
                <div className="col-md-3 mb-2 mb-md-3">
                    <Select
                        label={"Transfer to "}
                        className={"w-100"}
                        placeholder={"Select Store"}
                        options={storeList}
                        onChange={(e: any) => {
                            handleSelectStore(e);
                        }}
                        value={selectedStore}
                    />
                </div>
                <div className="col-md-9" >
                    <div style={{ bottom: 0 }}>
                        <div
                            className="col-md-5 position-relative p-0"
                            onClick={() => setPreviewTab(!previewTab)}
                            ref={searchTabContainer}
                        >
                            <label
                                className="inputs-label mb-2 fs-16 fw-600  secondary-color"
                            >
                                Search
                            </label>

                            <BarcodeSearch
                                className="w-100"
                                searchCallBack={(e: string) => {
                                    handleSearch(e);
                                }}
                                placeholder={"Search Barcode"}
                                isClearable={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {((productDataTable && productDataTable?.length > 0)) && (
                    <div>
                        <Table
                            AdditionalClassName="table-height-50"
                            columns={columns}
                            data={productDataTable?.map((item, index) => {
                                return {
                                    ...item,
                                    action: (
                                        <div className="d-flex align-items-center text-danger">
                                            <IoIosCloseCircleOutline
                                                className="fs-24"
                                                onClick={() => handleRemoveProduct(index, item?.id)}
                                            />
                                        </div>
                                    ),
                                };
                            })}
                        />
                    </div>
                )}
            </div>
            <div className="text-center mt-5 ">
                <Button
                    isDisabled={productDataTable?.length === 0 || !selectedStore}
                    className="w-25"
                    onClick={() => handleSubmit()}
                >
                    Submit
                </Button>
            </div>
        </>
    );
};

export default Index;
